<template>
    <div class="medical-records">
        <div class="row diet-section">
            <div class="col-12 mb-3">
                <div class="mobScroll">
                    <ul class="nav nav-tabs noWrap mb-0" role="tablist">
                        <li class="nav-item pl-0"><a class="nav-link" href="#"  @click.prevent="tab = 'workouts'" :class="(tab == 'workouts')?'active':''">Learn How to Workouts</a></li>
                        <li class="nav-item"><a class="nav-link" href="#"  @click.prevent="tab = 'exercise'" :class="(tab == 'exercise')?'active':''">Exercise for you</a></li>
                        <li class="nav-item"><a class="nav-link"  href="#"  @click.prevent="tab = 'recent'" :class="(tab == 'recent')?'active':''">Recent Exercise</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row mb-4 Exercise-section">
            <div class="col-12">
                <div class="card border-0">
                    <div class="card-body bg-transparent p-0">
                        <!-- Tab panes -->
                        <div class="tab-content">
                        	<howork-out v-if="tab == 'workouts'"></howork-out>
                        	<exercise-you v-else-if="tab == 'exercise'"></exercise-you>
                        	<recent-exercise v-else-if="tab == 'recent'"></recent-exercise>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import howorkout from './pages/how-to-workout'
	import exerciseyou from './pages/exercise_for_you'
	import recentexercise from './pages/recent-exercise'
    export default {
        name: "exercise",
        data() {
            return {
            	tab : 'workouts'
            }
        },
        components:{
        	howorkOut : howorkout,
        	exerciseYou: exerciseyou,
        	recentExercise: recentexercise
        },
        created(){
           this.pageName('Exercise and Yoga');
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/exercise/exercise_yoga.vue